import React from 'react';
import classNames from 'classnames';

import styles from './DurationBar.module.css';

export interface DurationBarProps {
  percent: number;
  className?: string;
  rounded?: boolean;
}

const getPercentBoundaries = (percent: number) => {
  let percentBoundaries = percent;
  if (percent > 100) {
    percentBoundaries = 100;
  }
  if (percent < 0) {
    percentBoundaries = 0;
  }
  return percentBoundaries;
};

const DurationBar: React.FunctionComponent<DurationBarProps> = ({ percent, className }) => {
  const percentBoundaries = getPercentBoundaries(percent);
  return (
    <div className={classNames(styles.durationBarContainer, className)}>
      <div className={styles.durationBarIndicator} style={{ width: `${percentBoundaries}%` }} />
    </div>
  );
};

export { DurationBar };
